import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_ACCOUNT_DELETE_REQUEST = createActionTypes('FETCH_ACCOUNT_DELETE_REQUEST');
export const APPROVED_ACCOUNT_DELETE_REQUEST = createActionTypes('APPROVED_ACCOUNT_DELETE_REQUEST');
export const REJECTED_ACCOUNT_DELETE_REQUEST = createActionTypes('REJECTED_ACCOUNT_DELETE_REQUEST');
